import script from "./YearGoals.vue?vue&type=script&setup=true&lang=ts"
export * from "./YearGoals.vue?vue&type=script&setup=true&lang=ts"

import "./YearGoals.vue?vue&type=style&index=0&id=6a4cc44e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a4cc44e"]])

export default __exports__